import "bootstrap/dist/css/bootstrap.css";

import React from "react";
import { Row, Col, Container } from "reactstrap";

import "../icofont.min.css";

// Web theme color root css
import "../components/colors.css";

import "../Terms.css";
import Tdscontact from "../components/Tdscontact";
import Tdsfooter from "../components/Tdsfooter";
import Tdsheader from "../components/Tdsheader";

export default function Terms() {
  return (
    <div className={"terms"}>
      {/* Navbar  */}
      <Tdsheader active={"terms"} isHome={false} />

      <div className={"section"} id={"terms"}>
        <h1 className={"heading mt-5 mb-1 ml-3 ml-sm-5"}>Terms & Conditions</h1>

        <Container className={"mt-5"}>
          <Row className={"mt-2 ml-2 mr-2"}>
            <Col xs={12}>
              <h4>1. Introduction</h4>
              <p className="text-justify">
                These Terms and Conditions govern the provision of hydraulic inspection, maintenance, and repair services by Opal Hydraulic.
              </p>
              <p className="text-justify">
                The Customer may request either:
              </p>
              <p>
                (a) periodic inspection and maintenance services for hydraulic equipment; or
                <br />
                (b) a one-off inspection and repair service for hydraulic equipment.
              </p>
              <p className="text-justify">
                By accepting these Terms and Conditions, the Customer acknowledges that no ongoing commitment or minimum service period is created. Either party may discontinue the business relationship at any time in accordance with these Terms.
              </p>

              <h4>2. Scope of Services</h4>

              <h5>2.1 Periodic Inspection Services</h5>
              <p className="text-justify">
                Periodic inspections may include, but are not limited to, the following:
              </p>
              <p>
                a) Assessment of the service life of hydraulic jacks and the potential need for replacement of rubber seals and components.
                <br />
                b) Visual inspection of moving metal parts, joints, levers, and related components.
                <br />
                c) Inspection of hydraulic oil quality and quantity.
                <br />
                d) Inspection for signs of oil leakage.
                <br />
                e) Operational testing without load.
                <br />
                f) Operational testing under load.
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 1:</em> Load testing is performed based on the customer's normal operating requirements and not necessarily at the equipment's maximum rated capacity.
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 2:</em> Although inspections do not extend to auxiliary attachments or accessories, Opal Hydraulic may provide guidance regarding safety issues, corrective actions, and recommended maintenance practices.
              </p>

              <h5>2.2 Inspection Reports</h5>
              <p className="text-justify">
                Inspection findings for each identified hydraulic unit shall be recorded and provided to the Customer using Opal Hydraulic's approved inspection checklist.
              </p>

              <h5>2.3 Repair Coordination</h5>
              <p className="text-justify">
                Where a hydraulic unit is found to be defective, Opal Hydraulic may, at the Customer's request, arrange collection, repair, and return of the equipment subject to the applicable fees set out in Section 3.
              </p>

              <h5>2.4 Repair Conditions</h5>
              <p>
                <strong>2.4.1</strong> If, after disassembly and assessment, major internal damage is discovered or required replacement parts are unavailable, Opal Hydraulic reserves the right to decline the repair.
                <br />
                <strong>2.4.2</strong> Where equipment is determined to be beyond economical or practical repair, it shall be returned to the Customer without additional charge.
                <br />
                <strong>2.4.3</strong> If, following workshop assessment, the repair cost is expected to exceed the original quotation, a revised quotation will be provided. No additional repair work will be undertaken without the Customer's approval.
              </p>

              <h4>3. Service Fees</h4>
              <p className="text-justify">
                For customers enrolled in the Periodic Inspection Program, the following fees shall apply during the first two years of participation:
              </p>
              <p>
                a) AUD $99 per year for inspection and support of up to five hydraulic units with capacities under 3 tonnes.
                <br />
                b) AUD $99 per year for each vehicle hoist or automotive lifting unit with a capacity under 3 tonnes.
                <br />
                c) A 30% discount on repair labour charges for defective equipment.
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 1:</em> Inspection fees for 4-tonne and 5-tonne hydraulic units shall be charged at 150% of the standard rate. Fees for equipment exceeding 5 tonnes shall be determined by mutual agreement.
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 2:</em> The annual fee of AUD $99 covers between one and five hydraulic units. Each additional group of up to five units will incur an additional AUD $99 annual fee.
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 3:</em> The repair discount applies to labour charges only and does not apply to replacement parts, freight, consumables, or third-party costs.
              </p>
              <p className="text-justify">
                <em className={"text-danger"}>Note 4:</em> The 30% repair discount is available only to customers participating in the Periodic Inspection Program and does not apply to one-off repair customers.
              </p>

              <h4>4. General Provisions</h4>

              <h5>4.1 Scheduling</h5>
              <p className="text-justify">
                Inspection appointments, equipment collection, and equipment return dates shall be scheduled by Opal Hydraulic and communicated to the Customer via SMS, email, or other agreed means.
              </p>

              <h5>4.2 Collection and Delivery</h5>
              <p className="text-justify">
                Opal Hydraulic representatives may collect and return equipment identified with an Opal Hydraulic asset or inspection code.
              </p>

              <h5>4.3 Term</h5>
              <p className="text-justify">
                This agreement shall remain in effect until terminated by either party.
              </p>

              <h5>4.4 Termination</h5>
              <p className="text-justify">
                Either party may terminate this agreement by providing not less than one month's written notice to the other party.
              </p>

              <h5>4.5 Updated Terms</h5>
              <p className="text-justify">
                Following two years of participation in the Periodic Inspection Program, Opal Hydraulic may issue updated Terms and Conditions. Continued use of the service after notification of updated terms shall constitute acceptance of those revised terms.
              </p>

              <h4>5. Warranty and Repair Terms</h4>
              <p className="text-justify">
                <em className={"text-danger"}>Note:</em> This section applies only to customers receiving one-off repair services.
              </p>

              <h5>5.1 Warranty Coverage</h5>
              <p className="text-justify">
                Repaired equipment is covered by a three (3) month workmanship warranty commencing from the date the repaired equipment is returned to the Customer.
              </p>
              <p className="text-justify">
                The warranty covers only defects arising directly from repair workmanship performed by Opal Hydraulic.
              </p>
              <p className="text-justify">
                Where a previously repaired fault reoccurs due to workmanship issues, Opal Hydraulic will rectify the fault at no additional labour cost.
              </p>

              <h5>5.2 Warranty Exclusions</h5>
              <p className="text-justify">
                The warranty shall be void where damage results from:
              </p>
              <p>
                a) misuse, abuse, or improper operation of the equipment;
                <br />
                b) operation contrary to manufacturer instructions;
                <br />
                c) overloading, modification, or unauthorised repair;
                <br />
                d) accidents, neglect, or external damage occurring after return of the equipment.
              </p>

              <h5>5.3 Additional Faults Discovered During Repair</h5>
              <p className="text-justify">
                If additional faults are identified during the repair process that materially affect the quoted repair cost, a revised quotation shall be provided. Repair work beyond the original quotation will only proceed following Customer approval.
              </p>
              <p className="text-justify">
                If approval is not granted, the equipment shall be returned without charge for the additional work not undertaken.
              </p>

              <h5>5.4 Repair Timeframes</h5>
              <p className="text-justify">
                Repair completion times are estimates only and cannot be guaranteed until the equipment has been inspected and assessed. An estimated completion date will be provided after evaluation.
              </p>

              <h4>6. Acceptance</h4>
              <p className="text-justify">
                By selecting the acceptance box, submitting a service request, or otherwise engaging Opal Hydraulic's services, the Customer confirms that they have read, understood, and agreed to these Terms and Conditions.
              </p>
              <p className="text-justify">
                These Terms and Conditions remain valid and binding unless amended, replaced, or withdrawn by Opal Hydraulic.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Contact Us Section Start  */}
      <div className="section contactus grapping" id="contact">
        <Tdscontact />
      </div>

      {/* Footer  Section Start */}
      <div className="">
        <Tdsfooter />
      </div>
    </div>
  );
}
